exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loader-fullscreen[data-v-efa0ba14]{background-color:hsla(0,0%,100%,.4);bottom:0;left:0;position:fixed;right:0;top:0;z-index:3000\n}\n.loader-fullscreen .spiner-example[data-v-efa0ba14]{left:50%;top:50%;position:fixed;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-efa0ba14","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/loader/Loader.vue
// module id = hqnx
// module chunks = 21